import api from 'api'

export type SubmitIndeedFlexOtpParams = {
  challengeToken: string
  code: string
}

export type SubmitIndeedFlexOtpResponse = {
  accessTokenExpiresAt: string
  deviceTokenExpiresAt: string | null
}

export const submitIndeedFlexOtp = async (
  params: SubmitIndeedFlexOtpParams
): Promise<SubmitIndeedFlexOtpResponse> => {
  const result = await api.post<SubmitIndeedFlexOtpResponse>(
    '/admin/indeed_flex/otp',
    params
  )
  return result.data
}
